import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Generate a unique session ID per browser tab
const SESSION_ID = `s_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

const PageViewTracker = () => {
  const location = useLocation();
  const lastPage = useRef('');

  useEffect(() => {
    const page = location.pathname;
    if (page === lastPage.current) return;
    lastPage.current = page;

    axios.post(`${API_URL}/api/analytics/pageview`, {
      page,
      session_id: SESSION_ID
    }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PageViewTracker;
